import { render, staticRenderFns } from "./SupplyDemandGoodsCard.vue?vue&type=template&id=d5d41a50&scoped=true"
import script from "./SupplyDemandGoodsCard.vue?vue&type=script&lang=js"
export * from "./SupplyDemandGoodsCard.vue?vue&type=script&lang=js"
import style0 from "./SupplyDemandGoodsCard.vue?vue&type=style&index=0&id=d5d41a50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d41a50",
  null
  
)

export default component.exports